import { productPage } from 'utils/pageTemplates/productPage';

const { getStaticProps, getStaticPaths, ProductPageComponent } = productPage({
  category: 'supplements',
});

export { getStaticPaths, getStaticProps };
export default ProductPageComponent;
